import { render, staticRenderFns } from "./goout.vue?vue&type=template&id=2006e617&scoped=true"
import script from "./goout.vue?vue&type=script&lang=js"
export * from "./goout.vue?vue&type=script&lang=js"
import style0 from "./goout.vue?vue&type=style&index=0&id=2006e617&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006e617",
  null
  
)

export default component.exports